import React from "react";
import parse, { domToReact } from "html-react-parser";
import LinkPreview from "../ProductDashboard/Emgpt/LinkPreview";
import CollapsibleDiv from "../ProductDashboard/Emgpt/CollapsibleDiv";
import HighchartFromText from "../ProductDashboard/Emgpt/HighchartFromText";

const TradeAnalysisRenderFromString = ({ htmlString, isStreaming = false }) => {
  if (typeof htmlString !== "string") {
    console.error(
      "TradeAnalysisRenderFromString expects a string but received:",
      htmlString,
    );
    return null;
  }

  return parse(htmlString, {
    replace: (domNode) => {
      if (domNode.name === "linkpreview") {
        const url = domNode.attribs?.url || "#";
        return <LinkPreview url={url} />;
      }

      if (domNode.name === "collapsiblediv") {
        return (
          <CollapsibleDiv isStreaming={isStreaming}>
            {domToReact(domNode.children)}
          </CollapsibleDiv>
        );
      }

      if (domNode.name === "chartrender") {
        return (
          <HighchartFromText chartText={domNode.childNodes?.[0]?.data || ""} />
        );
      }
    },
  });
};

export default TradeAnalysisRenderFromString;
